import { Typography, Box, Button } from "@mui/material";
import { useGoogleLogin } from "@react-oauth/google";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  BackButton,
  InstagramColorLogo,
  YouTubeColorLogo,
} from "../assets/icons";
import { CustomContainer } from "../components/CustomContainer";
import { ToastMessage } from "../helpers/ToastMessage";
import {
  fetchChannelSuggestionsList,
  setChannelSuggestionsState,
} from "../redux/features/channelSuggestionList/channelSuggestionListSlice";
import { colors } from "../styles/color";
import { setLoading } from "../redux/features";
import { Helmet } from "react-helmet-async";
export const AccountSetUp = () => {
  const [selectedButton, setSelectedButton] = React.useState("youtube");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const buttons = [
    {
      name: "youtube",
      label: "YouTube Channel",
      logo: <YouTubeColorLogo />,
      link: "/youtube-channel",
    },
    {
      name: "instagram",
      label: "Instagram Account",
      logo: <InstagramColorLogo />,
      link: "",
    }, // we'll override this
  ];

  const handleButtonClick = (buttonName: string) => {
    setSelectedButton(buttonName);
  };

  const onSuccessData = async (response: { access_token?: any }) => {
    console.log("✅ OAuth Success Data:", response); // 🔍 Log received access_token

    dispatch(setLoading(true));

    try {
      const res = await dispatch(
        fetchChannelSuggestionsList(response?.access_token)
      );
      const data = res?.payload?.data;

      console.log("📦 API Response Data:", data); // 🔍 Log response from suggestions API

      if (data) {
        dispatch(setChannelSuggestionsState(data));
        console.log(
          "➡️ Navigating to:",
          selectedButton === "youtube" ? "/youtube-channel" : "/sign-up"
        );
        navigate(
          selectedButton === "youtube" ? "/youtube-channel" : "/sign-up",
          selectedButton === "youtube"
            ? { state: { fromAccountSetup: true } }
            : undefined
        );
      } else {
        dispatch(setChannelSuggestionsState([]));
        console.warn("⚠️ Empty data received, navigating anyway");
        navigate(
          selectedButton === "youtube" ? "/youtube-channel" : "/sign-up",
          selectedButton === "youtube"
            ? { state: { fromAccountSetup: true } }
            : undefined
        );
      }
    } catch (error) {
      console.error("❌ Error fetching suggestions:", error);
    }

    dispatch(setLoading(false));
  };

  const login = useGoogleLogin({
    onSuccess: (res) => onSuccessData(res),
    scope: "https://www.googleapis.com/auth/youtube.readonly",
  });

  const handleSetup = () => {
    if (selectedButton === "instagram") {
      const authUrl = `https://www.instagram.com/oauth/authorize?force_reauth=true&client_id=${process.env.REACT_APP_INSTAGRAM_APP_ID}&redirect_uri=${process.env.REACT_APP_INSTAGRAM_REDIRECT_URI}&response_type=code&scope=instagram_business_basic%2Cinstagram_business_manage_messages%2Cinstagram_business_manage_comments%2Cinstagram_business_content_publish%2Cinstagram_business_manage_insights`;

      window.location.href = authUrl;

      const checkClosed = setInterval(() => {
        //   const urlParams = new URLSearchParams(window.location.search);
        //   console.log('urlParams: ', urlParams);
        //   const code = urlParams.get("code");
        //   console.log('code: ', code);
        //   if (code) {
        //     exchangeCodeForToken(code);
        //     clearInterval(checkClosed);
        // }
      }, 1000);
    } else if (selectedButton === "youtube") {
      login();
    } else {
      ToastMessage({ type: "error", message: "Please select an option" });
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    console.log("urlParams: ", urlParams);
    const code = urlParams.get("code");
    console.log("code: ", code);
    if (code) {
      localStorage.setItem("instagramCode", code);
      navigate("/instagram-account", { state: { fromAccountSetup: true } });
      // exchangeCodeForToken(code);
      // clearInterval(checkClosed);
    }
  }, []);

  // const exchangeCodeForToken = async (code: string) => {
  //   const clientId = process.env.REACT_APP_INSTAGRAM_APP_ID;
  //   const clientSecret = process.env.REACT_APP_INSTAGRAM_APP_SECRET;

  //   if (!clientId || !clientSecret) {
  //     console.error("Missing Instagram credentials");
  //     alert("Instagram credentials not configured");
  //     return;
  //   }

  //   const proxyUrl = "https://cors-anywhere.herokuapp.com/";
  //   const tokenUrl = `${proxyUrl}https://api.instagram.com/oauth/access_token`;

  //   const formData = new FormData();
  //   formData.append("client_id", clientId);
  //   formData.append("client_secret", clientSecret);
  //   formData.append("grant_type", "authorization_code");
  //   formData.append(
  //     "redirect_uri",
  //     process.env.REACT_APP_INSTAGRAM_REDIRECT_URI!
  //   );
  //   formData.append("code", code);

  //   try {
  //     const response = await fetch(tokenUrl, {
  //       method: "POST",
  //       body: formData,
  //     });

  //     if (!response.ok) {
  //       const errorData = await response.json();
  //       console.error("Instagram API Error:", errorData);
  //       alert(
  //         `Instagram API Error: ${
  //           errorData.error_message || errorData.error || "Unknown error"
  //         }`
  //       );
  //       return;
  //     }

  //     const data: any = await response.json();
  //     // setAccessToken(data.access_token);
  //   } catch (error) {
  //     console.error("Error exchanging code for token:", error);
  //     alert("Failed to exchange code for token. Please try again.");
  //   }
  // };

  return (
    <>
      <Helmet>
        <title>Set up your account in just minutes without hassle</title>
        <meta
          name="description"
          content="Set up your profile in a few simple steps. A secure process ensures safety, trusted access, and a smooth onboarding experience for every Quickfluence user."
        />

        {/* Canonical */}
        <link rel="canonical" href="https://quickfluence.com/" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Quickfluence | Set Up Your Account Fast and Hassle-Free"
        />
        <meta
          property="og:description"
          content="Set up your profile in a few simple steps. A secure process ensures safety, trusted access, and a smooth onboarding experience for every Quickfluence user."
        />
        <meta property="og:url" content="https://quickfluence.com/" />
        <meta property="og:site_name" content="quickfluence" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en" />
        <meta
          property="og:image:alt"
          content="Quickfluence account setup page"
        />
        <meta
          property="og:image"
          content="https://quickfluence.com/static/media/WorkWithImg.7fac11e7ad4c6bde8580.png"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Box>
        <CustomContainer>
          <Box
            sx={{
              height: "100%",
              background: colors.dark[800],
              borderRadius: "24px",
              color: "white",
              p: { sm: "39px 35px 0px 35px", xs: "20px 10px" },
              display: "block",
              minHeight: "calc(100vh - 169px)",
            }}
          >
            <Box>
              <Button variant="text" onClick={() => navigate("/dashboard")}>
                <BackButton />
              </Button>
            </Box>
            <Box
              sx={{
                width: { sm: "100%", xs: "auto" },
                maxWidth: "438px",
                m: "auto",
                mt: { sm: "60px", xs: "30px" },
                mb: { sm: "60px", xs: "30px" },
                textAlign: "center",
              }}
            >
              <Box mt={"39px"}>
                <Typography variant="h1">Set Up Your Account</Typography>
              </Box>
              <Box mt={"7px"}>
                <Typography variant="body2" color={colors.gray[300]}>
                  Hey! It looks like you are new... Let’s set up your account.
                </Typography>
              </Box>

              <Box
                display="flex"
                mt="46px"
                gap="10px"
                justifyContent={
                  buttons.length === 1 ? "center" : "space-between"
                }
              >
                {buttons.map((button) => (
                  <Box
                    key={button?.name}
                    onClick={() => handleButtonClick(button?.name)}
                    sx={{
                      width: "207px",
                      height: {
                        xs: "180px",
                        sm: "209px",
                      },
                      background: colors.dark[600],
                      borderRadius: "10px",
                      border:
                        selectedButton === button?.name
                          ? `1.5px solid ${colors.basics.primary}`
                          : "1.5px solid transparent",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      sx={{
                        height: {
                          xs: "72px",
                          md: "96px",
                        },
                        width: {
                          xs: "72px",
                          md: "96px",
                        },
                        m: {
                          xs: "24px",
                          sm: "auto",
                        },
                        background:
                          selectedButton === button?.name
                            ? "#a175ff26"
                            : colors.dark[100],
                        borderRadius: "50px",
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "center",

                        mt: "30px",
                        mb: "30px",
                      }}
                    >
                      {button.logo}
                    </Box>
                    <Box
                      sx={{
                        marginBottom: {
                          xs: "10px",
                          sm: "24px",
                        },
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color:
                            selectedButton === button?.name
                              ? colors.basics.primary
                              : colors.basics.white,
                          fontSize: {
                            xs: "15px",
                            sm: "16px",
                          },
                        }}
                      >
                        {button?.label}
                      </Typography>
                    </Box>
                  </Box>
                ))}
                {/* <button onClick={initiateInstagramLogin}>iuiuhjiuhghjfgh ghf ghh</button> */}
              </Box>

              <Box pt={"60px"}>
                <Button
                  variant="contained"
                  sx={{ width: "100%" }}
                  onClick={handleSetup}
                >
                  Start Setup
                </Button>
              </Box>
            </Box>
          </Box>
        </CustomContainer>
      </Box>
    </>
  );
};
